import React from 'react';

import SavedSearch from '@buyside/components/presentation/SavedSearch/savedSearch';

import { useIdeaIndexSavedSearchQuery } from '@interfaces/graphql-typings';

const IdeaIndexSavedSearchContainer: React.FC = () => {
  const { data, loading } = useIdeaIndexSavedSearchQuery();

  return (
    <SavedSearch loading={loading} savedSearchList={data?.ideasSavedSearchList} searchType="Idea" />
  );
};

export default IdeaIndexSavedSearchContainer;
